/**
 * AI-generated code, moderated by Lukasz Zygmanski
 */
import {useMemo} from 'react';
import {useLocation} from 'react-router-dom';

import {useAuthUser, useGroups} from '@/hooks/useAuth';
import {useEntitlements} from '@/hooks/useEntitlements';
import {releaseNotes} from '@/shared/release-notes/utils/releaseNotes';
import {
  getSeenReleaseNoteIds,
  getUnseenReleaseNotes,
  getVisibleReleaseNotes,
  hasReleaseNotesSeenState,
} from '@/shared/release-notes/utils/releaseNoteUtils';

export function useVisibleReleaseNotes() {
  const groups = useGroups();
  const entitlements = useEntitlements();
  const releaseNotesReady = !!groups && !!entitlements;
  const visibleReleaseNotes = useMemo(
    () =>
      groups && entitlements
        ? getVisibleReleaseNotes(releaseNotes, groups, entitlements)
        : [],
    [entitlements, groups]
  );
  const visibleReleaseNoteIds = useMemo(
    () => visibleReleaseNotes.map(releaseNote => releaseNote.id),
    [visibleReleaseNotes]
  );

  return {releaseNotesReady, visibleReleaseNoteIds, visibleReleaseNotes};
}

export function useHasNewVisibleReleaseNotes() {
  const location = useLocation();
  const {data: authUser} = useAuthUser();
  const userId = authUser?.userId || authUser?.username;
  const {releaseNotesReady, visibleReleaseNotes} = useVisibleReleaseNotes();

  return (
    releaseNotesReady &&
    !location.pathname.startsWith('/releases') &&
    !!userId &&
    hasReleaseNotesSeenState(userId) &&
    getUnseenReleaseNotes(visibleReleaseNotes, getSeenReleaseNoteIds(userId))
      .length > 0
  );
}
